import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes, st } from './SubscriptionInfo.st.css';

type SubscriptionInfoProps = {
  price?: string;
  paymentCount?: number;
};

export const SubscriptionInfo: FC<SubscriptionInfoProps> = ({
  price,
  paymentCount,
}) => {
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();

  if (!price || paymentCount === undefined) {
    return null;
  }

  return (
    <div
      data-hook="details-subscription-info"
      className={st(classes.root, { isMobile })}
    >
      <Text className={classes.subscriptionInfo}>
        {t('service.payment.subscription.monthly-payments-of-price', {
          count: paymentCount,
          price,
        })}
      </Text>
    </div>
  );
};
